export const dashboardColors = ['#2ECC71', '#102B7B', '#F2994A', '#29B6F6', '#F5AF00', '#AB22FF'];
